<template>
  <div class="info-card">
    <span class="count">{{ count|formatBigNumber }}</span>
    <div class="label">
      <span class="label-text">{{ label || $t(labelI18nKey) }}</span>
      <i v-if="visibleArrow" class="label-icon el-icon-arrow-right"></i>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    count: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    labelI18nKey: {
      type: String,
      required: false
    },
    visibleArrow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.info-card {
  width: 310px;
  height: 110px;
  background: #f7f7f7;
  box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.08);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .count {
    font-size: 26px;
    font-weight: 500;
    color: #303133;
    line-height: 36px;
    margin-bottom: 8px;
  }

  .label {
    .label-text {
      color: #606266;
      line-height: 20px;
      vertical-align: middle;
    }

    .label-icon {
      font-size: 16px;
      margin-left: 8px;
      vertical-align: middle;
    }
  }
}
</style>
